import {airbridge} from './airbridge'
import {albums} from './albums'
import {auth} from './auth'
import {clients} from './clients'
import {eztexting} from './eztexting'
import {faces} from './faces'
import {featureSettings} from './featuresettings'
import {forms} from './forms'
import {microposts} from './microposts'
import {permissions} from './permissions'
import {persons} from './persons'
import {photos} from './photos'
import {segments} from './segments'
import {staff} from './staff'

export const api = {
  airbridge,
  albums,
  auth,
  clients,
  eztexting,
  faces,
  featureSettings,
  forms,
  microposts,
  permissions,
  persons,
  photos,
  segments,
  staff,
}
